"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventLabelCartButtonClickEnum = void 0;
var EventLabelCartButtonClickEnum;
(function (EventLabelCartButtonClickEnum) {
    EventLabelCartButtonClickEnum["ExpressCheckout"] = "Express-Checkout";
    EventLabelCartButtonClickEnum["ContinueShopping"] = "Continue shopping";
    EventLabelCartButtonClickEnum["PaypalExpress"] = "PaypalExpress";
    EventLabelCartButtonClickEnum["ProceedToOrderData"] = "Proceed to order data";
    EventLabelCartButtonClickEnum["AddPackagingVariant"] = "Add packaging variant";
    EventLabelCartButtonClickEnum["SelectPackagingVariant"] = "Select packaging variant";
    EventLabelCartButtonClickEnum["AmazonPayExpress"] = "AmazonPay";
    EventLabelCartButtonClickEnum["Payback"] = "Collect PAYBACK";
    EventLabelCartButtonClickEnum["GooglePayExpress"] = "GooglePayExpress";
    EventLabelCartButtonClickEnum["ApplePayExpress"] = "ApplePayExpress";
    EventLabelCartButtonClickEnum["BuyNow"] = "Buy now";
    EventLabelCartButtonClickEnum["BuyWithPaypalRegular"] = "Buy with paypal";
    EventLabelCartButtonClickEnum["BuyWithAmazonPayRegular"] = "Buy with amazonPay";
    EventLabelCartButtonClickEnum["BuyWithGooglePayRegular"] = "Buy with googlePay";
    EventLabelCartButtonClickEnum["BuyWithApplePayRegular"] = "Buy with applePay";
})(EventLabelCartButtonClickEnum || (exports.EventLabelCartButtonClickEnum = EventLabelCartButtonClickEnum = {}));
//# sourceMappingURL=EventLabelCartButtonClickEnum.js.map